module.exports = __webpack_public_path__ + "img/logo-1.593d07c.png";